import io from "socket.io-client";
import {SocketEvent} from "./constant.ts";
import store from "@/stores/store";
class WebSocket {
    // khởi tạo instance
    createInstance(store) {
      let websocket = new WebSocket(store);
      websocket.store = store;
      return websocket
    }

    // get instance static
    getInstance(store) {
        if (!this.instance) {
            this.instance = this.createInstance(store);
        }
        return this.instance;
    }


    // Xử lí kết nối nhận gửi gói tin socket io
    onReceivePushMessage() {    
        const me = this
        me.socket = io(window[`config`].socketUrl,{
          reconnection: true,
          reconnectionAttempts : 5,
          transports: ['websocket'] 
        });
        const userInfo = JSON.parse(localStorage.getItem("UserData"));
        var context = {
          TenantID: userInfo.TenantID,
          UserID: userInfo.UserID,
          ApplicationCode: "PROCESS"
        }
    
        me.socket.on('connect', function () {
              
          /*
           * biến lưu socketId trả về từ server sau khi kết nối thành công
           * dùng để phân biệt với thông tin gửi từ server xem có phải phản hồi do mình gửi lên không
           */
          me.socket.on(SocketEvent.OnJoinRoomSuccess, function (data) {
              console.log("OnJoinRoomSuccess");
          });
    
          me.socket.emit(SocketEvent.JoinRoomSelf, context);
    
        });
        
        //Ngắt kết nối
        me.socket.on('disconnect', function (msg) {
        });
        


        //Khi có sự thay đổi trên socket server Nhận dữ liệu về qua một new_event sau đó callback func
        me.socket.on('OnDataChanged', function (res) {
            me.store.dispatch('notification/setNewNotify',res)
        });
    }

  };

const webSocketInstance = new WebSocket().getInstance(store)

export default webSocketInstance
